import { Dialog, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
// import { SAVE_SEARCH } from '../store/store-mutations';
import { makeStyles } from '@material-ui/styles';
import DataTable from '../toolkit/DataTable/DataTable';

const useStyles = makeStyles(() => ({
  root: {
    padding: '0 !important'
  }
}));

const BuscadorPaginado = props => {
  const classes = useStyles();

  // const getAdvanceSearchDto = () => {
  //   if (!props.noSearch) {
  //     setLoadingSearchDto(true);
  //     fetch(getSearchDtoUrl())
  //       .then(response => response.json())
  //       .then(searchDto => {
  //         setSearchFields(searchDto);
  //         const storedSearch = getStoredSearch();
  //         if (storedSearch && storedSearch.advance) {
  //           setAdvanceSearchModel(storedSearch.advance);
  //           calculateAdvanceFilterCount();
  //         }
  //         setLoadingSearchDto(false);
  //       })
  //       .catch(error => {
  //         setLoadingSearchDto(false);
  //         console.error('Error fetching search DTO:', error);
  //       });
  //   }
  // };

  return (
    <Dialog
      maxWidth={props.maxWidth || 'lg'}
      open={props.open}
      scroll="paper"
      fullWidth
      // fullScreen
      onClose={props.onClose}
      // disableEscapeKeyDown
      classes={
        {
          // paper: classes.dialogPaper
        }
      }
    >
      {/* <DialogTitle>{props.datosConfig.titulo}</DialogTitle> */}
      <DialogContent classes={{ root: classes.root }}>
        <DataTable
          title={props.datosConfig.titulo}
          disableReload
          settings={props.datosSettings}
          onItemClick={props.onItemClick}
          onReloadTable={() => props.onReloadTable()}
          fileName={props.datosConfig.servicio}
          toolbarActionsEnd={[
            <IconButton key="close" onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          ]}
          {...props.list}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BuscadorPaginado;
